<template>

    <div class="ai-chat-page">
        <div class="chat-container">
            <!-- <div class="pl-1 font-18">{{ pageTitle }}</div> -->
            <div class="messages">
                <div v-for="(mesg, index) in messages" :key="index"
                    :class="['message', mesg.sender == 'AI' ? 'message-left' : 'message-right']">
                    <!-- 用户消息 and AI消息-->
                    <div class="typewriter" v-if="mesg.message !== 'thinking'" v-html="mesg.message"></div>

                    <!-- 思考中... -->
                    <div v-if="mesg.message === 'thinking'" class="thinking">
                        <i class="el-icon-loading mr-1"></i>
                        <span>Deepseek正在思考中，请您稍等……</span>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>
<script>

import aiNav from '../inc/aiNav.vue';
export default {
    components: { aiNav },
    data() {
        return {
            userdata: {},
            messages: [
                // {sender: "AI", message: "Hi，我是 中投产业专家～很高兴遇见你！"}

            ],
            userInput: { sender: "user", message: "" },
            historyList: [
                { sender: "user", message: "比亚迪股份有限公司拿地数据和投资趋势分析" },
                { sender: "user", message: "宁德时代股份有限公司拿地数据和投资趋势分析" },
            ],
            type: 1, //1土地，2专利，3研发
            model: 1, //1: v3 2: R1
            id: 1,
            isUserScrolling: false, // 标志用户是否正在手动滚动
            pageTitle: '',
            pageType: '',
        };
    },

    created() {
        this.userdata = this.getuseriformation();
        console.log(this.userdata);
        this.type = this.$route.query.type;
        this.model = this.$route.query.model;
        this.id = this.$route.query.id;
        this.industryChat = this.$route.query.industryChat; //用来判断是否是行业分析
        this.pageType = this.$route.query.pageType; //用来判断行业分析，有些是没有单独接口要调详情
    },
    mounted() {
        if (this.industryChat == 1 && !this.pageType) {
            this.getIndutryChat();
        } else {
            this.getDetail();
        }
        // 移除所有带有 hyc-common-markdown__ref-list 类名的元素
        const elements = document.querySelectorAll('.hyc-common-markdown__ref-list');
        elements.forEach((element) => {
            element.remove();
        });
    },
    methods: {
        getIndutryChat() {
            let aiChatData = JSON.parse(localStorage.getItem('aiChatData'));
            let that = this;
            let type = this.type;
            let id = this.splicing('id', this.$route.query.id); //市场规模和竞争格局id
            let ajaxUrl = this.$api.common.analyse.chatDetail() + "?type=" + type + id;
            console.log(ajaxUrl);
            // return;
            // 模拟用户输入
            this.userInput = { sender: "user", message: aiChatData.title };
            // if (!this.userInput.message.trim()) return;
            // 添加用户消息
            this.messages.push(this.userInput);
            // 添加思考动画
            this.messages.push({ sender: "AI", message: "thinking" });
            const userInput = this.userInput; // 保存用户输入
            this.userInput = "";
            this.pageTitle = aiChatData.title;
            document.title = aiChatData.title;
            // 发送请求
            this.$axios.get(ajaxUrl, { headers: { AuthToken: this.userdata.token } }).then(function (res) {
                if (res.data.success) {
                    console.log(res);
                    let thinkingProcess = '', result = '';
                    result = res.data.data.content;
                    thinkingProcess = res.data.data.reason; // 假设后端返回的思考过程字段为 reason
                    let fullMessage = result;
                    // console.log(result,"",thinkingProcess);
                    if (thinkingProcess && thinkingProcess) {
                        fullMessage = `<div class="thinking-process">\n${thinkingProcess}</div><div class="result">${result}</div>`;

                    }

                    that.messages.pop();
                    that.messages.push({ sender: "AI", message: fullMessage });
                } else {
                    that.messages.push({ sender: "AI", message: '系统出错' });
                }
            }).catch(function (error) {
                // 请求失败处理 console.log(error);
            });
        },
        getDetail() {
            var _this = this;
            let aiChatData = JSON.parse(localStorage.getItem('aiChatData'));
            var ajaxurl = this.$api.common.analyse.detail() + '?id=' + this.id;
            // return;
            // 模拟用户输入
            this.userInput = { sender: "user", message: aiChatData.title };
            // if (!this.userInput.message.trim()) return;
            // 添加用户消息
            this.messages.push(this.userInput);
            // 添加思考动画
            this.messages.push({ sender: "AI", message: "thinking" });
            const userInput = this.userInput; // 保存用户输入
            this.userInput = "";
            this.pageTitle = aiChatData.title;
            
            this.$axios.get(ajaxurl).then(function (res) {
                console.log('详情', res, ajaxurl);
                if (res.data.success) {
                    let data = res.data.data;
                    console.log(_this.baseInfo);
                    let  result = '';
                    if (_this.pageType  == 'industryChancePoint') {
                        result = data.industryChancePoint;
                        _this.pageTitle += '行业机会点';
                    }else if (_this.pageType  == 'abilityRequirement') {
                        result = data.abilityRequirement;
                        _this.pageTitle += '成功要素与能力要求';
                    }else if(_this.pageType  == 'entryStrategy') {
                        result = data.entryStrategy
                        _this.pageType += '进入策略';
                    }else if(_this.pageType  == 'businessMode'){
                        result = data.businessMode;
                        _this.pageTitle += '商业模式';
                    }else if(_this.pageType  == 'riskTip'){
                        result = data.riskTip
                        _this.pageTitle += '风险提示';
                    }
                    
                    let fullMessage = result;
                    fullMessage = `<div class="result">${result}</div>`;
                    _this.messages.pop();
                    _this.messages.push({ sender: "AI", message: fullMessage });
                    document.title = _this.pageTitle;
                } else {
                    _this.messages.push({ sender: "AI", message: '系统出错' });
                }
            }).catch(function (error) {
                // 请求失败处理 console.log(error);
            });
        },
        typeText(message, index) {
            if (index < message.message.length) {
                message.displayMessage += message.message.charAt(index);
                requestAnimationFrame(() => {
                    this.typeText(message, index + 1);
                });
            }
        },
        typeAnswer(answer, callback, isResult = false) {
            let i = 0;
            const timer = setInterval(() => {
                if (i < answer.length) {
                    this.displayedText.push(answer[i]);
                    i++;
                } else {
                    clearInterval(timer);
                }
            }, 100);
        },
        scrollToCenter() {
            const container = this.$el.querySelector(".messages");
            const chatContainer = this.$el.querySelector(".chat-container");
            console.log(container, chatContainer);
            if (container && chatContainer) {
                const containerHeight = container.scrollHeight;
                const chatHeight = chatContainer.clientHeight;

                // 计算滚动位置，让内容保持在正中间
                const scrollTop = (containerHeight - chatHeight) / 2;
                chatContainer.scrollTop = scrollTop > 0 ? scrollTop : 0;
            }
        },
    },
};
</script>

<style lang="scss">
.typewriter {
    p span[style*="font-size: 10px"] {
        /* 匹配含特定样式的 span */
        display: none !important;
    }

    p:has(> :empty:last-child) {
        /* 匹配内容为空的<p> */
        display: inline;
    }

    .hyc-common-markdown__ref-list {
        display: none !important;
    }

    blockquote {
        p {
            display: inline-block;
        }
    }

    p,
    h1,
    h2,
    h4,
    h3,
    h5,
    ul,
    ol,
    li,
    span {
        background: rgba(0, 0, 0, 0) !important;
    }

    table {
        width: 100%;
        border: 1px solid #E0E0E0 !important;
        border-collapse: collapse;
        border-spacing: 0;
        margin: 0 auto;
    }

    hr {
        border-top: 1px solid #999 !important;
        margin: 25px 0;
    }

}

.ai-chat-page {
    width: 100%;
}

.chat-container {
    // width: 100%;
    // max-width: 1200px;
    // height: 90%;
    background-color: #ffffff;
    border-radius: 10px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    display: flex;
    flex-direction: column;
    padding: 20px;
    min-height: 90vh;
    height: calc(100vh - 40px);
    overflow-y: auto;

}

.messages {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 10px;
    // justify-content: center; /* 垂直居中 */
    align-items: center;
    /* 水平居中 */
    // text-align: center; /* 文本居中 */
    width: 80%;
    margin: 0 auto;
}

.message {
    // max-width: 100%;
    padding: 10px 15px;
    border-radius: 15px;
    font-size: 14px;
    line-height: 2;
    word-wrap: break-word;
}

.message-left {
    align-self: flex-start;
    // background-color: #e5e7ed;
    color: #333;
    border-top-left-radius: 0;
    width: 1400px;
}

.message-right {
    align-self: flex-end;
    background-color: #37a3ff;
    color: #fff;
    border-top-right-radius: 0;
}

.thinking {
    display: flex;
    align-items: center;
    color: #666;
    font-size: 14px;
    font-style: italic;
    background-color: #e5e7ed;
    border-radius: 15px;
    border-top-left-radius: 0;
    padding-left: 20px;
    line-height: 40px;
    padding: 10px 15px;
}

.el-icon-loading {
    animation: spin 1s linear infinite;
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}

.meun-box {
    position: fixed;
    bottom: 50%;
    left: 20px;
    padding: 3px;
    border-radius: 10px;
    background-color: #fff;
    box-shadow: 2px 2px 7.7px 0px rgba(146, 159, 202, .19), 0px 0px 1px 1px rgba(255, 255, 255, .45) inset;

    .item:hover {
        background-color: #eee;
        border-radius: 10px;
    }

    span {
        padding: 7px;
        cursor: pointer;
        display: inline-block;
    }
}

.history-container {
    padding: 10px;
    width: 1200px;
    height: 90vh;

    .history-date {
        padding: 10px;
        border-radius: 10px;
        border-bottom: 1px solid #f0f0f0;
        font-size: 14px;
        color: #666;
        background-color: #fff;
        margin-bottom: 10px;
        cursor: pointer;

        &:hover {
            box-shadow: 2px 2px 7.7px 0px rgba(146, 159, 202, .19), 0px 0px 1px 1px rgba(255, 255, 255, .45) inset;
        }
    }
}
</style>